import { render, staticRenderFns } from "./CellRendererActions.vue?vue&type=template&id=f5972632&scoped=true"
import script from "./CellRendererActions.vue?vue&type=script&lang=js"
export * from "./CellRendererActions.vue?vue&type=script&lang=js"
import style0 from "./CellRendererActions.vue?vue&type=style&index=0&id=f5972632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5972632",
  null
  
)

export default component.exports